import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, of as observableOf} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import {Endpoints} from '../config/endpoints';
import {APP_VERSION} from '../config/version';
import {User} from '../dto/user';

import {BaseService} from './base.service';

@Injectable({providedIn: 'root'})
export class AuthService {

    constructor(private router: Router, private service: BaseService) {
    }


    get user(): User {
        return JSON.parse(localStorage.getItem('user') || null);
    }

    get isOrgAdmin(): boolean {
        let isOrgAdmin = false;

        if (this.user) {
            this.user.UserRole.ModuleList.forEach(pModule => {
                if (pModule.Name === 'ADMIN') {
                    pModule.ResourceList.forEach(pResource => {
                        if (pResource.Name === 'ADMIN_ACCESS' && pResource.IsSubscribed === true) {
                            isOrgAdmin = true;
                            return;
                        }
                    });
                }
                if (isOrgAdmin) {
                    return;
                }
            });
        }


        return isOrgAdmin;
    }

    get isSuperAdmin(): boolean {
        let isSuperAdmin = false;

        if (this.user) {
            this.user.UserRole.ModuleList.forEach(pModule => {
                if (pModule.Name === 'ADMIN') {
                    pModule.ResourceList.forEach(pResource => {
                        if (pResource.Name === 'SUPER_ADMIN_ACCESS' && pResource.IsSubscribed === true) {
                            isSuperAdmin = true;
                            return;
                        }
                    });
                }
                if (isSuperAdmin) {
                    return;
                }
            });
        }
        return isSuperAdmin;
    }


    getAccessToken(pUsername: string, pPassword: string): Observable<any> {
        return this.service.postData(Endpoints.login, new HttpParams({
            fromObject: {
                username: pUsername,
                password: pPassword,
                grant_type: 'password',
                client_uuid: this.service.uuid,
                client_type: 'BROWSER',
                app_version_name: APP_VERSION
            }
        }), false)
            .pipe(map(pTokenResponse => {
                if (pTokenResponse['access_token']) {
                    localStorage.setItem('access_token', pTokenResponse['access_token']);
                    localStorage.setItem('refresh_token', pTokenResponse['refresh_token']);

                    this.service.getData(Endpoints.self).subscribe(pSelfResponse => {
                        localStorage.setItem('user', JSON.stringify(pSelfResponse['Data']['User']));
                        if (this.isSuperAdmin) {
                            window.location.href = 'organization/list';
                        } else {
                            window.location.href = 'dashboard';
                        }

                    });
                }
                return pTokenResponse;
            }));
    }

    refreshAccessToken(): Observable<any> {
        return this.service
            .postData(Endpoints.login, new HttpParams({
                fromObject: {
                    refresh_token: this.service.refreshToken,
                    grant_type: 'refresh_token'
                }
            }), false)
            .pipe(map(response => {
                if (response['access_token']) {
                    localStorage.setItem('access_token', response['access_token']);
                    localStorage.setItem('refresh_token', response['refresh_token']);
                }
                return observableOf(response);
            }));
    }

    logout(): Observable<boolean> {
        return this.service.getData(Endpoints.logout, {}, true).pipe(map(() => {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user');
            return true;
        }));

    }

    hasAccess(pModuleNameEnum: string, pResourceEnum: string): boolean {
        let hasAccess = false;

        if (this.isSuperAdmin) {
            return true;
        }

        this.user.UserRole.ModuleList.forEach(pModule => {
            if (hasAccess) {
                return;
            }
            if (pModule.Name === pModuleNameEnum.toUpperCase()) {
                pModule.ResourceList.forEach(pResource => {
                    if (pResource.Name === pResourceEnum.toUpperCase() && (this.isOrgAdmin || pResource.IsSubscribed === true)) {
                        hasAccess = true;
                        return;
                    }
                });
            }
        });

        return hasAccess;
    }

    hasAccessByOrg(pModuleNameEnum: string, pResourceEnum: string): boolean {
        let hasAccess = false;

        if (this.isSuperAdmin) {
            return true;
        }

        this.user.UserRole.ModuleList.forEach(pModule => {
            if (pModule.Name === pModuleNameEnum.toUpperCase()) {
                pModule.ResourceList.forEach(pResource => {
                    if (pResource.Name === pResourceEnum.toUpperCase()) {
                        hasAccess = true;
                        return;
                    }
                });
            }
        });

        return hasAccess;
    }
}
